import { Megaphone } from "lucide-react";
import { Reveal } from "@/lib/motion";

const pub = (p) => (p ? `${window.location.origin}/api/public/img/${p}` : null);

export default function Announcements({ announcements }) {
  if (!announcements || announcements.length === 0) return null;
  return (
    <section id="annonces" className="border-b border-white/10 py-16 md:py-20" data-testid="section-annonces">
      <div className="mx-auto max-w-6xl px-5">
        <Reveal>
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-korban-gold">
            <Megaphone size={14} /> Communication
          </p>
          <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
            Communiqués &amp; annonces
          </h2>
        </Reveal>
        <div className="mt-8 grid gap-5 md:grid-cols-2">
          {announcements.map((a) => (
            <Reveal key={a.id}>
              <article
                className={`h-full rounded-2xl border p-6 ${a.pinned ? "border-korban-gold/50 bg-korban-gold/[0.07]" : "border-white/10 bg-white/[0.04]"}`}
                data-testid={`announcement-${a.id}`}
              >
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-display text-lg font-semibold leading-snug text-white">{a.title}</h3>
                  {a.pinned ? (
                    <span className="shrink-0 rounded-full bg-korban-gold px-3 py-1 text-[0.65rem] font-bold uppercase tracking-wider text-korban-navy">
                      À la une
                    </span>
                  ) : null}
                </div>
                <p className="mt-3 whitespace-pre-line text-[0.93rem] leading-relaxed text-slate-300">{a.body}</p>
                <p className="mt-4 text-xs text-slate-500">{(a.created_at || "").slice(0, 10)} · KORBAN CONSULTING</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
